import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { config } from "../config";
import { buildLocalizedPath, getLanguageFromPath } from "../i18n/routing";

const Fallback = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const languageFromPath = getLanguageFromPath(location.pathname) || config.fallbackLanguage;
        const contactPath = buildLocalizedPath('/contact', languageFromPath);
        navigate(contactPath, { replace: true });
    }, [location.pathname, navigate]);

    return (
        <div>404 NOT FOUND</div>
    );
}

export default Fallback;
